import Copy from './Copy';

export default Copy;
